import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do I need a lot of money to start?",
    a: "No. Our Starter plan is for people who are just learning or saving up. You get the same honest advice no matter the size of your budget.",
  },
  {
    q: "Are you a bank or do you hold my money?",
    a: "No. We're an advisor. Your money stays in your accounts and your properties stay in your name. We just help you make smart choices.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes. Your subscription is month-to-month (or year-to-year). Cancel from your account with one click. No fees, no questions.",
  },
  {
    q: "Do you take a cut of what I make?",
    a: "Never. You only pay your subscription. We don't take commissions or hidden fees on your deals. Our success is keeping you happy long-term.",
  },
  {
    q: "How do I pay?",
    a: "Credit or debit card, through a secure checkout.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 lg:py-40 bg-ink-surface border-y border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="data-label mb-6">/ Common Questions</div>
          <h2 className="font-display text-4xl sm:text-5xl leading-[0.95] tracking-tight">
            Honest answers, <span className="italic text-white/60">no fine print.</span>
          </h2>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          <Accordion type="single" collapsible className="border-t border-white/10">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/10"
              >
                <AccordionTrigger className="text-left py-6 hover:no-underline group">
                  <div className="flex items-center gap-6">
                    <span className="font-mono text-[11px] tracking-[0.3em] text-gold">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display text-xl sm:text-2xl text-white group-hover:text-gold transition-colors">
                      {item.q}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-white/70 text-[15px] leading-relaxed pl-14 pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
